export enum GameStates {
  setTeams = 'setTeams',
  setScoreTarget = 'setScoreTarget',
  setAvailableTime = 'setAvailableTime',
  waitForRoundStart = 'waitForRoundStart',
  roundInProgress = 'roundInProgress',
  roundEnded = 'roundEnded',
  gameEnded = 'gameEnded'
}
